import React from "react"
import PropTypes from "prop-types"
import styled, { css } from "styled-components"
import { Link } from "gatsby"
import { breakpoints } from "../../../theme"
import { useTranslation } from "react-i18next"

const PrixMinusWrapper = styled.div`
  position: relative;
  transition: opacity 3ms ease-in-out;
`

const Picture = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 5px;
  max-width: 110px;
  max-height: 110px;

  @media (min-width: ${breakpoints.medium}px) {
    max-width: 174px;
    max-height: 174px;
  }
`

const Circle = styled.div`
  width: 110px;
  height: 110px;
  aspect-ratio: 1/1;
  background-color: var(--brand-soleil-d-hiver);
  border-radius: 50%;
  position: absolute;
  z-index: -1;
  @media (min-width: ${breakpoints.medium}px) {
    width: 174px;
    height: 174px;
  }
`
const Image = styled.div`
  img {
    display: block;
    width: 110px !important;
    height: 110px !important;
    object-fit: contain !important;

    @media (min-width: ${breakpoints.medium}px) {
      width: 174px !important;
      height: 174px !important;
    }
  }
`

const TeaserStyle = css`
  opacity: 1;
  transition: opacity 0.3s ease-in-out;
  text-decoration: none;
  color: var(--font-color);

  &:hover {
    opacity: 0.85;
  }
`
const Title = styled.h4`
  font-family: var(--font);
  font-weight: 500;
  font-size: 14px;
  line-height: 19px;
  opacity: 1;
  margin: 25px 0px 0px 0px;
  @media (min-width: ${breakpoints.medium}px) {
    font-size: 16px;
  }
`

const Icon = styled.div`
  width: 64px;
  height: 64px;
  position: absolute;
  left: 0;
  bottom: -15px;
  border: 2px solid #fff;
  padding: 5px;
  border-radius: 12px;
  background-color: var(--brand-p-plus);
  background-size: cover;
  background-repeat: no-repeat;
  font-weight: 300;
  font-size: 12px;
  line-height: 19px;
  overflow: hidden;

  > svg {
    position: absolute;
    right: -12px;
    bottom: -12px;
    color: #fff;
  }
`

const IconText = styled.div`
  z-index: 2;
  position: relative;
  > b {
    font-weight: 700;
  }
`

const Rabatt = styled.span`
  font-weight: 500;
  font-size: 16px;
  line-height: 23px;

  @media (min-width: ${breakpoints.medium}px) {
    font-size: 20px;
  }
`

const Excerpt = styled.div`
  font-size: 12px;
  line-height: 1.8;
  opacity: 0.5;

  @media (min-width: ${breakpoints.medium}px) {
    display: block;
    font-size: 14px;
    margin-top: 0.8em;
  }
`

const Legal = styled.div`
  font-size: 10px;
  opacity: 0.75;
  margin-top:8px;
`

const Titular = styled.div`
  font-size: 10px;
  margin-top:3px;
`

const StyledLink = styled(Link)`
  ${TeaserStyle}
`
const StyledA = styled.a`
  ${TeaserStyle}
`
const StyledDiv = styled.div`
  ${TeaserStyle}
`

const PrixMinus = ({
  title,
  price,
  image,
  excerpt,
  discount,
  to,
  href,
  onClick,
  legal = false,
  titular
}) => {
  const {t} = useTranslation()
  const Card = () => (
    <PrixMinusWrapper>
      <Picture>
        <Image>{image}</Image>
        {discount && (
          <Icon>
            <IconText>
              prix<b>minus</b>
              <br />
              <Rabatt>{discount}%</Rabatt>
            </IconText>
            <svg width="50" height="50">
              <use xlinkHref="#plus" />
            </svg>
          </Icon>
        )}
        <Circle />
      </Picture>
      <div style={{ padding: "0 0 0 6px" }}>
        <Title>
          {title}
          {price && (
            <>
              <br />
              {price}CHF
            </>
          )}
        </Title>
        {excerpt && <Excerpt>{excerpt}</Excerpt>}
        {legal && <Legal>{t("prix_minus_legal")}</Legal>}
        {legal && titular && <Titular>{t("prix_minus_titular")}<br/>{titular}</Titular>}
      </div>
    </PrixMinusWrapper>
  )
  switch (true) {
    case to !== null && to !== undefined:
      return (
        <StyledLink to={to}>
          <Card />
        </StyledLink>
      )

    case href !== null && href !== undefined:
      return (
        <StyledA href={href} target="_blank" rel="noreferrer">
          <Card />
        </StyledA>
      )

    case onClick !== null && onClick !== undefined:
      return (
        <StyledDiv onClick={onClick}>
          <Card />
        </StyledDiv>
      )

    default:
      return <Card />
  }
}

PrixMinus.propTypes = {
  title: PropTypes.string.isRequired,
  price: PropTypes.string.isRequired,
  image: PropTypes.oneOfType([PropTypes.object, PropTypes.string]).isRequired,
  excerpt: PropTypes.string.isRequired,
  discount: PropTypes.string,
  to: PropTypes.string,
  onClick: PropTypes.func,
  href: PropTypes.string,
}

export { PrixMinus }
